export function toBase64(uuid: string | undefined | null) {
  if (uuid == null || uuid === undefined || uuid === '') {
    return '';
  }
  return Buffer.from(uuid).toString('base64');
}

export function fromBase64(uuidBase64: string | undefined | null) {
  if (uuidBase64 == null || uuidBase64 === undefined || uuidBase64 === '') {
    return '';
  }
  return Buffer.from(uuidBase64, 'base64').toString();
}
